import request from '../../utils/request';

export function getOrderTickets(params) {
  return request('/order-tickets', {
    method: 'GET',
    params: params,
  });
}
